import { tw } from "@careinfo/tailwind";
import { ColumnDef } from "@tanstack/react-table";
import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import TrialGroupedTable from "../Reusable/TrialBalanceGroupedTable";
import Filter from "./Filter";
import Spinner from "../Reusable/Spinner";
 

const columns: ColumnDef<any, any>[] = [
  {
    accessorKey: "account_name",
    header: "Account Name",
  },
  {
    accessorKey: "debit",
    header: "Debit",
  },
  {
    accessorKey: "credit",
    header: "Credit",
  },
];

export default () => {
  const [searchParams] = useSearchParams();

  const getFilters = useCallback(() => {
    const object = Object.fromEntries(searchParams.entries());
    return object;
  }, [searchParams]);

  const { data: trialBalanceData, isLoading: isDataLoading } = useGetHook({
    queryKey: [`trial-balance-grouped-${JSON.stringify(getFilters())}`],
    url: `${APIS.TRIAL_BALANCE}grouped/`,
    params: {
      ...getFilters(),
    },
  });

  return (
    <div className={tw`space-y-2`}>
      <Filter />
 
      {isDataLoading ? (
        <Spinner />
      ) : (
        <TrialGroupedTable data={trialBalanceData} />
      )}
    </div>
  );
};
